<template>
    <div class="add-manage-rooms-container">
        <div class="add-button">
          <el-button @click="addRoom" :disabled="addingRoom">
            <IconBase
              :height="24"
              :width="24"
              :view-box="`0 0 24 24`"
              :fill="addingRoom ? '#3F4357' : '#E7E6FA'"
            >
              <IconPlus />
            </IconBase>
            <span class="button-text">Add New Room</span>
          </el-button>
        </div>
        <div class="gear-icon">
            <Visibility v-if="controls['BREAKOUTS_VISIBILITY']"/>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Constants from "../Constants";
import axios from "../../client";
import IconBase from "../IconBase";
import IconPlus from "../icons/IconPlus";
import { getSocketPayload } from "../../utils";
import Visibility from './Visibility';

export default {
  components: {
    IconBase,
    IconPlus,
    Visibility
  },
  data() {
    return {
      addingRoom: false
    };
  },
  methods: {
    async addRoom() {
      this.addingRoom = true;
      const lastRoom = this.sortRooms(this.rooms).pop();
      const rank = lastRoom.rank ? lastRoom.rank + 1 : 1;
      const breakoutRoomName = `${this.mainRoom.name} ${Constants.BREAKOUT_ROOM_PREFIX} ${rank}`;
      try {
        const response = await axios.post("/api/rooms/", {
          mainRoom: this.mainRoom.name,
          name: breakoutRoomName,
          parent: this.mainRoom._id,
          rank: rank
        });
        this.socket.emit(
          "NEW_ROOM_CREATED",
          getSocketPayload({ roomId: response.data._id })
        );
        this.$emit("new-room-added");
      } catch (err) {
        console.log(err);
      } finally {
        this.addingRoom = false;
      }
    }
  },
  computed: {
    ...mapState({
      mainRoom: state => state.rooms.mainRoom,
      rooms: state => state.rooms.rooms,
      tokens: state => state.user.tokens,
      controls: state => state.user.controls
    }),
    ...mapGetters("rooms", {
      sortRooms: "sortRooms",
      socket: "getSocket"
    })
  }
};
</script>

<style scoped>
button.el-button {
  padding: unset !important;
  width: 100%;
  height: 40px;
  border: 1px solid #373b4d;
  border-radius: 8px;
  background-color: #1e1e29;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #e7e6fa;
}

button.el-button.is-disabled {
  color: #3f4357;
  background-color: #232530;
  border: 1px solid #373b4d;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
}

button.el-button:hover {
  background-color: #373a4b !important;
  border: 1px solid #595d78;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
}

button.el-button:active,
button.el-button:focus {
  background-color: #545871 !important;
  border: 1px solid #737a9d;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25),
    inset 0px 0px 10px rgba(0, 0, 0, 0.3);
}
>>> button.el-button span,
>>> button.el-button.is-disabled span {
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-text {
  padding: 3px 0px 0 6px;
}

.add-manage-rooms-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.add-button {
    flex: 1;
}

.gear-icon {
    padding-left: 6px;
}
</style>
